import { roundTo } from "./formatNumbers"

const calculateTotals = (totals, lieferstellen) => {
	// console.log(totals)
	const totalSums = [
		(totals.totalAmount / 100) * (totals.per100Netto),
		parseFloat(totals.productExtra * (totals.totalAmount / 100)),
		parseFloat(totals.lieferfahrzeug),
		parseFloat(totals.lieferstelle),
		parseFloat(totals.schlauch),
		parseFloat(totals.wunschtermin),
		parseFloat(totals.express),
		parseFloat(totals.termin),
		totals.ggvs ? parseFloat(totals.ggvs * lieferstellen) : 0,
		parseFloat(totals.bezahlaufschlag)
	]

	const sum = totalSums.reduce((prev, curr) => prev + curr)
	return roundTo(sum, 2)
}

export default calculateTotals
